// extracted by mini-css-extract-plugin
module.exports = {"dialogueFormContent":"add-tag-dialog-component_dialogueFormContent__3V3Rl"};